
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/business-support",
      function () {
        return require("private-next-pages/business-support.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/business-support"])
      });
    }
  